import {Flip, ScrollTrigger} from "../LibrariesImport";

export default class CardHover {
    static init() {
        let cards = document.querySelectorAll('.card-related-post.sector');
        cards.forEach((card) => {
            this.cardHover(card);
        });
    }
    static cardHover(card) {
        const animConfig = {
            ease: "power2.out",
            duration: 0.5
        };

        if (ScrollTrigger.isTouch !== 1) {
            card.addEventListener("mouseenter", e => {
                const head = card.querySelector(".card-data-head");
                const state = Flip.getState(head);

                head.style.top = "2rem";
                head.style.bottom = "auto";

                Flip.from(state, {
                    ...animConfig
                });
            });

            card.addEventListener("mouseleave", e => {
                const head = card.querySelector(".card-data-head");
                const state = Flip.getState(head);

                head.style.top = "";
                head.style.bottom = "";

                Flip.from(state, {
                    ease: animConfig.ease,
                    duration: 0.4
                });
            });
        }
    }
}

